// Used to calculate the divide by price based on product quantity amount for product variations and breakdown quantity tiles.
export const calculateDivideByQuantityAndPrice = (
  tileData: {
    quantityPerPackaging: number;
    price: number;
    unitOfMeasurement: string;
    itemNumber: string;
  }[],
) => {
  const minQuantityItems = tileData.reduce((minItem, currentItem) => {
    return currentItem.quantityPerPackaging < minItem.quantityPerPackaging
      ? currentItem
      : minItem;
  });

  const minUnit = minQuantityItems.unitOfMeasurement;
  const minQuantity = minQuantityItems.quantityPerPackaging;

  const results = tileData
    .filter((item) => item.quantityPerPackaging !== minQuantity)
    .map((item) => {
      const dividedQuantity = item.quantityPerPackaging / minQuantity;
      const divideByPrice = item.price / dividedQuantity;
      return {
        itemNumber: item.itemNumber,
        divideByLowestQuantity: divideByPrice,
        minUnit,
      };
    });
  return results;
};

export const getDivideByQuanitityAndPriceItem = (
  tileData: {
    quantityPerPackaging: number;
    price: number;
    unitOfMeasurement: string;
    itemNumber: string;
  }[],
  itemNumber: string,
) => {
  return calculateDivideByQuantityAndPrice(tileData).find((item) => {
    return item.itemNumber === itemNumber;
  });
};
